import React, {useState} from 'react';
import { TextInput, Checkbox, Button, Group, Box, Textarea, Stack, Text, ActionIcon, Alert, PasswordInput, Anchor } from '@mantine/core';
import { useForm } from '@mantine/form';
import { LoginFormValidations } from './validations/FormValidations';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { login } from '../../redux/slices/authSlice';
import { IconAlertCircle } from '@tabler/icons-react';
import { MODAL_TYPE_ENUM } from '../../enums/CommonEnums';
import useInfoModal from '../../hooks/useInfoModal';
import { AppDataService } from '../../services/AppDataService';
import { useDisclosure } from '@mantine/hooks';
import ResetPasswordRequestForm from './ResetPasswordRequestForm';

const LoginForm = () => {
  const form = useForm({
    initialValues: {
      username: '',
      password: '',
      rememberMe: false
    },

    validate: {
      username: LoginFormValidations.username,
      password: LoginFormValidations.password,
    },
  });
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const openModal = useInfoModal();
  const navigate = useNavigate();
  const [loginFormOpened, { toggle }] = useDisclosure(true);

  const handleLogin = async () => {
    try {
      setLoading(true);
  
      const webResp = await AppDataService.Login({
        email: form.values.username,
        password: form.values.password
      });

      const responseData = webResp.getResponse();
  
      setLoading(false);
  
      if(responseData.error) return openModal(MODAL_TYPE_ENUM.LOGIN_FAILURE, responseData.error.message);
  
      dispatch(login(responseData.data.data));
    }
    catch(err) {
      setLoading(false);
      openModal(MODAL_TYPE_ENUM.GENERAL_FAILURE, err.message);
    }
  }

  const handleToggleForms = (e) => {
    e.preventDefault();
    toggle();
  }

  return (
    <>
    {
      loginFormOpened ? (
        <Box maw={'95%'} mx="auto">
          <form onSubmit={form.onSubmit(handleLogin)}>
            <Stack>
              <TextInput
                size='md'
                withAsterisk
                label="Username"
                name="username"
                placeholder="Username"
                {...form.getInputProps('username')}
              />
              <PasswordInput
                size='md'
                withAsterisk
                name="password"
                label="Password"
                placeholder="Password"
                {...form.getInputProps('password')}
              />
              <Checkbox 
                size='md'
                label='Remember Me'
                name="rememberMe"
                {...form.getInputProps('rememberMe')}
              />
            </Stack>
            <Group position="center" mt="md" mx="sm">
              <Button color='cyan' type="submit" compact loading={loading}>Login</Button>
              <Button color='green' compact onClick={() => navigate('/registration')}>Register</Button>
            </Group>
          </form>
        </Box>
      ) : (
        <ResetPasswordRequestForm />
      )
    }
      <Text ta="center" mt="md">
        { loginFormOpened ? 'Forgot Password? ' :  'Know your password? ' }
        <Anchor href="#" weight={700} onClick={(event) => handleToggleForms(event)}>
          { loginFormOpened ? 'Reset Password' : 'Login' }
        </Anchor>
      </Text>
    </>
  );
}

export default LoginForm;